import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from '../../shared/services/message.service';
import { GameService } from '../../shared/services/game.service';
import { StorageConstants } from '../../shared/constants/storage.constants';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent {
  constructor(private gameService: GameService, private messageService: MessageService, private router: Router) { }

  async startGame() {
    await this.gameService.startGame()
      .then(game => {
        sessionStorage.setItem(StorageConstants.GameID, game.GameID);
        this.router.navigate(['/game/' + game.GameID + '/configure']);
      })
      .catch(() => {
        this.messageService.showError('Er is iets mis gegaan tijdens het aanmaken van het spel, herlaad de pagina en probeer het opnieuw');
      });
  }
}
